var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetZoomToDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.401 28h-4.524v-1.576h4.52c.562 0 1.022-.46 1.022-1.022v-4.524h1.576v4.52A2.599 2.599 0 0 1 25.401 28zM3.576 9.122H2V4.598A2.601 2.601 0 0 1 4.598 2h4.52v1.576h-4.52c-.562 0-1.022.46-1.022 1.022v4.524zM9.235 28H4.71a2.601 2.601 0 0 1-2.598-2.598v-4.524H3.69v4.52c0 .562.46 1.022 1.022 1.022h4.524V28zM27.884 9.122h-1.576V4.598c0-.562-.46-1.022-1.021-1.022h-4.524V2h4.524a2.601 2.601 0 0 1 2.597 2.598v4.524zM22.876 22.876H7.122V7.122h15.754v15.754zM8.698 21.3h12.606V8.7H8.698V21.3z",
    fill: "#83888D",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetZoomToDefault);
export default __webpack_public_path__ + "static/media/reset-zoom-to-default.62cbf05e0af7021d73882c849c2fd298.svg";
export { ForwardRef as ReactComponent };